import React from 'react'

import './Backdrop.scss'

const Backdrop = (props) => {
  const {
    children
  } = props

  return (
    <div className='Backdrop'>
      {children}
    </div>
  )
}
Backdrop.displayName = 'Backdrop'

export default Backdrop



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Backdrop/Backdrop.js